/*
  Collection of custom validation rules for transfers form
*/
import { required, numeric } from '../../helpr/generic-validation-rules';

/*
  Transfer Instruction Field Defaults
*/
export const transferInstructionObj = obj => {
  return {
    fields: {
      salutation: {
        value: obj.salutation,
        style: {}
      },
      title: {
        value: obj.title,
        style: {}
      },
      firstName: {
        value: obj.firstName,
        style: {}
      },
      lastName: {
        value: obj.lastName,
        style: {}
      },
      middleName: {
        value: obj.middleName,
        style: {}
      },
      transferAmount: {
        value: obj.transferAmount,
        style: {}
      },
      purchaseDate: {
        value: obj.purchaseDate,
        style: {}
      },
      taxStatus: {
        value: obj.taxStatus,
        style: {}
      },
      graduatedTaxStatus: {
        value: obj.graduatedTaxStatus,
        style: {}
      },
      transferDate: {
        value: obj.transferDate,
        style: {}
      },
      settlementDate: {
        value: obj.settlementDate,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

/*
  Authorization Field Defaults
 */
export const authorizationObj = obj => {
  return {
    fields: {
      fromRegistryBpId: {
        value: obj.fromRegistryBpId,
        style: {}
      },
      fromRegistryAccountNumber: {
        value: obj.fromRegistryAccountNumber,
        style: {}
      },
      toType: {
        value: obj.toType,
        style: {}
      },
      toDepositoryBpId: {
        value: obj.toDepositoryBpId,
        style: {}
      },
      toDepositoryAccountNumber: {
        value: obj.toDepositoryAccountNumber,
        style: {}
      },
      toRegistryBpId: {
        value: obj.toRegistryBpId,
        style: {}
      },
      toRegistryAccountNumber: {
        value: obj.toRegistryAccountNumber,
        style: {}
      },
      nonStockProfit: {
        value: obj.nonStockProfit,
        style: {}
      },
      toTaxStatus: {
        value: obj.toTaxStatus,
        style: {}
      },
      toGraduatedTaxStatus: {
        value: obj.toGraduatedTaxStatus,
        style: {}
      },
    },
    dynamicFields: {}
  }
}

/*
  Trade Transfer Form (Transfer Instruction) Fields Configuration
  Validation rules setup for use-validation hook
*/
export const transferInstructionValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    salutation: [required],
    title: [],
    firstName: [required],
    lastName: [required],
    middleName: [required],
    // emailAddress: [required],
    transferAmount: [required, numeric],
    purchaseDate: [],
    taxStatus: [required],
    graduatedTaxStatus: [],
    transferDate: [required],
    settlementDate: [required]
  },
  dynamicFields: {}
}

export const authorizationValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    fromRegistryBpId: [required],
    fromRegistryAccountNumber: [required],
    toType: [required],
    toDepositoryBpId: [required],
    toDepositoryAccountNumber: [required],
    toRegistryBpId: [required],
    toRegistryAccountNumber: [required],
    nonStockProfit: [required],
    toTaxStatus: [required],
    toGraduatedTaxStatus: []
  },
  dynamicFields: {}
}

